<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencilAlt, faTrash, faFileDownload, faSpinner } from '@fortawesome/free-solid-svg-icons';

import Pagination from '@/components/Pagination';
import { fetchDownload } from '@/api/course';

library.add( faPencilAlt, faTrash, faFileDownload, faSpinner );

export default {
  name: 'ModuleCourseList',
  components: {
    Pagination,
  },
  computed: {
    ...mapState('course/collection', [
      'items',
      'pagination',
      'isLoading',
    ]),
    page: {
      get() {
        return this.pagination.page;
      },
      set(page) {
        this.setPage(page);
        this.fetch(this.query);
      },
    },
    query() {
      const { query } = this.$route;
      return query.q || null;
    },
  },
  watch: {
    query: function(newQuery, oldQuery) {
      if (newQuery === oldQuery) {
        return;
      }
      this.fetch(newQuery);
    },
  },
  methods: {
    ...mapActions('course/collection', [
      'fetch',
    ]),
    ...mapMutations('course/collection', [
      'setPage',
    ]),
    ...mapActions('course/item', [
      'remove',
    ]),
    confirmDelete(item) {
      this.$dialog.confirm(`Are you sure you want to delete <strong>${item.title}</strong>?`, { loader: true, html: true })
        .then(dialog => this.remove(item.id).then(() => {
          this.fetch().then(() => dialog.close());
        }))
        .catch(() => {})
      ;
    },
    download(item) {
      fetchDownload(item);
    }
  },
  created() {
    this.fetch(this.query);
  },
};
</script>
<template>
  <div class="box">
    <div class="d-flex justify-content-between mb-3">
      <h2>Courses</h2>
      <div class="actions">
        <router-link :to="{ name: 'courses-create' }" class="btn btn-primary">
          New Course
        </router-link>
      </div>
    </div>
    <table>
      <caption>
        <Pagination :pagination="pagination" :type="'courses'" v-model="page"></Pagination>
      </caption>
      <thead>
        <tr>
          <th>Title</th>
          <th class="w-25">Actions</th>
        </tr>
      </thead>
      <tbody>
      <tr v-if="isLoading">
        <td colspan="8" class="text-center">
          <font-awesome-icon icon="spinner" size="3x" spin class="mt-3 mb-3" />
        </td>
      </tr>
      <tr v-else-if="!items.length">
        <td colspan="8" class="text-center">
          There are no courses
        </td>
      </tr>
      <tr v-else v-for="(item, index) in items" :key="item.id" :class="{ primary: index % 2 === 0 }">
        <td>{{ item.title }}</td>
        <td class="w-25">
          <a @click="download(item)" class="pointer text-info mr-3">
            <font-awesome-icon icon="file-download" />
          </a>
          <router-link :to="{ name: 'courses-edit', params: { id: item.id } }" class="mr-3">
            <font-awesome-icon icon="pencil-alt" />
          </router-link>
          <a @click="confirmDelete(item)" class="pointer text-danger">
            <font-awesome-icon icon="trash" />
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
